import { NestedPieChart } from "@toast-ui/react-chart";
import { Grid, Card } from "@mui/material";
import IngredientsDetailsDrawer from "./IngredientsDetailsDrawer";
import { useState } from "react";
import {
  extractIdFromIngredientString,
  extractIngredientName,
} from "../../helpers/appUtils";

export const Chart = ({ data, technofunctionality, userId }) => {
  const [selectedIngredient, setSelectedIngredient] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const options = {
    theme: {
      chart: {
        fontFamily: "Verdana",
      },
      series: {
        areaOpacity: 20,
      },
    },
    chart: {
      title: technofunctionality,
      height: 400,
      width: 470,
    },
    series: {
      selectable: true,
      sectors: {
        radiusRange: {
          inner: "20%",
          outer: "40%",
        },
      },
      productPlatforms: {
        radiusRange: {
          inner: "55%",
          outer: "80%",
        },
      },
      ingredients: {
        areaOpacity: 1,
        radiusRange: {
          inner: "55%",
          outer: "100%",
        },
      },
    },

    exportMenu: {
      visible: false,
    },
    tooltip: {
      template: (model, defaultTemplate, theme) => {
        return `
       <div style="
        position: absolute;
        background-color: #212529;
        width: 200px;
        height: auto;
        text-align: center;
        color: white;
          ">
            <p style="margin: 1px;">${model.category}</p>
              <div class="toastui-chart-tooltip-series-wrapper" style="font-weight: normal; font-family: Verdana, sans-serif; font-size: 12px; color: #ffffff;">
      <div class="toastui-chart-tooltip-series">
          <span class="toastui-chart-series-name">
    <i class="toastui-chart-icon" style="background: #00bd9f"></i>
    <span class="toastui-chart-name">${extractIngredientName(
      model?.data[0]?.label
    )} </span>
  </span>
          <span class="toastui-chart-series-value">${model?.data[0]?.percentValue?.toFixed(
            2
          )}%&nbsp;&nbsp;${model?.data[0]?.value}</span>
        </div>
    </div>
          </div>`;
      },
    },
  };

  const openDrawer = (rowData) => {
    if (!rowData) return;
    setSelectedIngredient(rowData);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setSelectedIngredient(null);
    setDrawerOpen(false);
  };

  return (
    <>
      {data && (
        <Grid item xs={4}>
          <Card variant="outlined">
            <NestedPieChart
              data={data}
              options={options}
              onSelectSeries={(e) => {
                if (!e.ingredients) return;
                openDrawer(
                  extractIdFromIngredientString(e?.ingredients[0]?.name)
                );
              }}
            />
          </Card>
        </Grid>
      )}

      <IngredientsDetailsDrawer
        isOpen={drawerOpen}
        onClose={closeDrawer}
        selectedIngredient={selectedIngredient}
        view_from={"Chart"}
        userId={userId}
      />
    </>
  );
};
